import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
@Injectable({
  providedIn: 'root',
})
export class CommonService {
  qty: number = 1;
  constructor(
   private title: Title,
   private meta: Meta,
  ) {}

  setMetaTags(title:string, desc:string) {
    const pageTitle = title;
    const metaDescription = desc;
    this.title.setTitle(pageTitle);
    this.meta.updateTag({ name: 'description', content: metaDescription });
  }

  addQTY() {
    this.qty++;
    return this.qty;
  }
  subQTY() {
    if (this.qty > 1) {
      this.qty--;
    } else {
      this.qty = 0;
    }
    return this.qty;
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getLocation(){
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      const city = localStorage.getItem('city');
      return city ? JSON.parse(city) : {};
    }
    return {};
  }

  createSlugUrl(value: string): string {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  removeSlugUrl(value: string): string {
    return String(value || '')
      .replace(/-/g, ' ')
      .replace(/\band\b/g, '&')
      .trim();
  }
}
